module.exports = __webpack_public_path__ + "media/images/ups-affe300736dcaaef347ea271fb636e03.svg";